import { IUser } from "types/auth"
import { home, order, manageProduct, manageAgent, campaign, logsetting } from "assets/icons";
import { AppstoreOutlined } from "@ant-design/icons";




interface IMenu {
    title: string
    path: string
    icon: React.ReactNode
    children?: IMenu[]
    permissionList: string[]
    key: string
}

export const menuList: IMenu[] = [
    {
        title: 'หน้าหลัก',
        icon: home,
        path: '/dashboard',
        key: '1',
        permissionList: [

        ],
    },
    {
        title: 'คำสั่งซื้อ',
        icon: order,
        path: '/order',
        key: '2',
        permissionList: [

        ],
    },
    {
        title: 'จัดการสินค้า',
        icon: manageProduct,
        path: '/manage-product',
        key: '3',
        permissionList: [

        ],
    },
    {
        title: 'ตัวแทน',
        icon: manageAgent,
        path: '/manage-agent',
        key: '4',
        permissionList: [

        ],
    },
    // {
    //     title: 'แคมเปญ',
    //     icon: campaign,
    //     path: '/campaign',
    //     key: '5',
    //     permissionList: [

    //     ],
    // },
    {
        title: 'คลังสต็อกแผนก',
        icon: <AppstoreOutlined style={{ fontSize: 20, color: "#417B97" }} />,
        path: '/department-stock',
        key: '5',
        permissionList: [],
    },
    {
        title: "ตั้งค่า",
        icon: logsetting,
        path: "/settings",
        key: "6",
        permissionList: [],
    },

]


export const menuPermission = (user: IUser | null | undefined, menu: IMenu) => {
    if (!user) return false

    const role = user.role?.name

    if (!role) return false

    if (menu.permissionList.includes(role)) {
        return true
    }

    return false

}


